// utils/toast.js
import toast from "react-hot-toast";

export const showSuccess = (message) => {
  toast.success(message, {
    position: "top-center",
    duration: 3000,
  });
};

export const showError = (message) => {
  toast.error(message, {
    position: "top-center",
    duration: 4000,
  });
};

export const exitError = (message) => {
  toast.error(message, {
    position: "top-center",
    duration: 8000,
  });
};

export const showLoading = (message) => {
  return toast.loading(message, {
    position: "top-center",
  });
};

export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

export default {
  success: showSuccess,
  error: showError,
  loading: showLoading,
  dismiss: dismissToast,
};
